<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="店铺">-->
<!--                  <el-input  v-model="queryForm.shopId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="收货人">
                  <el-input style="width: 200px;" v-model="queryForm.consignee"></el-input>
              </el-form-item>
              <el-form-item label="电话">
                  <el-input style="width: 200px;" v-model="queryForm.contactNumber"></el-input>
              </el-form-item>
<!--              <el-form-item label="标签">-->
<!--                  <el-input  v-model="queryForm.labelName"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="省份编号">
<!--                  <el-input  v-model="queryForm.provinceId"></el-input>-->
                  <el-select v-model="queryForm.provinceId" placeholder="请选择" style="width: 200px;">
                      <el-option v-for="(item, index) in provinceIdList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="城市编号">
<!--                  <el-input  v-model="queryForm.cityId"></el-input>-->
                  <el-select v-model="queryForm.cityId" placeholder="请选择" style="width: 200px;">
                      <el-option v-for="(item, index) in cityIdList2" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="区域">
<!--                  <el-input  v-model="queryForm.areaId"></el-input>-->
                  <el-select v-model="queryForm.areaId" placeholder="请选择" style="width: 200px;">
                      <el-option v-for="(item, index) in areaIdList2" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="街道">
<!--                  <el-input  v-model="queryForm.streetId"></el-input>-->
                  <el-select v-model="queryForm.streetId" placeholder="请选择" style="width: 200px;">
                      <el-option v-for="(item, index) in streetIdList2" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopShopAddressList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopShopAddress"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editShopShopAddress(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopShopAddress(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopShopAddressList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopShopAddressList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="shopId"-->
<!--        label="店铺ID"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="consignee"
        label="收货人"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="contactNumber"
        label="电话"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="labelName"-->
<!--        label="标签"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="provinceId"
        label="省份编号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="cityId"
        label="城市编号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="areaId"
        label="区域id"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="streetId"
        label="街道id"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="title"-->
<!--        label="地址概述"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="address"
        label="地址"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="detailAddress"
        label="详细的地址"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="latitude"
        label="纬度"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="longitude"
        label="经度"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isDefault"
        label="是否是默认地址"
        width="180"
      >
          <template slot-scope="scope">
            {{scope.row.isDefault ? '是' : '否'}}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="添加时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopShopAddress(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopShopAddress(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopShopAddress(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopShopAddressStates[shopShopAddressState]"
      :visible.sync="showDialog"
      width="60%"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopShopAddress"
          ref="shopShopAddressForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="店铺ID"-->
<!--            prop="shopId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopShopAddress.shopId"-->
<!--              :disabled="shopShopAddressState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="收货人"
            prop="consignee"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopShopAddress.consignee"
              :disabled="shopShopAddressState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="电话"
            prop="contactNumber"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopShopAddress.contactNumber"
              :disabled="shopShopAddressState == 'check'"
            ></el-input>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="标签"-->
<!--            prop="labelName"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 200px;"-->
<!--              v-model="shopShopAddress.labelName"-->
<!--              :disabled="shopShopAddressState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
            <el-form-item
                label="地址"
                prop="address"
            >
                <!--            <el-input-->
                <!--              size="small"-->
                <!--              v-model="shopShopAddress.address"-->
                <!--              :disabled="shopShopAddressState == 'check'"-->
                <!--            ></el-input>-->
                <location
                    style='width: 200px;'
                    :areaTreeDate="provinceIdList"
                    :longitude="shopShopAddress.longitude"
                    :latitude="shopShopAddress.latitude"
                    :provinceId="shopShopAddress.provinceId"
                    :cityId="shopShopAddress.cityId"
                    :areaId="shopShopAddress.areaId"
                    :streetId="shopShopAddress.streetId"
                    :address="shopShopAddress.address"
                    :disabled="shopShopAddressState == 'check'"
                    @getLocation="getLocation"
                ></location>
            </el-form-item>
          <el-form-item
            label="省份编号"
            prop="provinceId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopShopAddress.provinceId"-->
<!--              :disabled="shopShopAddressState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                size="small"
                style='width: 200px;'
                v-model="shopShopAddress.provinceId"
                :disabled="shopShopAddressState == 'check'"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in provinceIdList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="城市编号"
            prop="cityId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopShopAddress.cityId"-->
<!--              :disabled="shopShopAddressState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  size="small"
                  style='width: 200px;'
                  v-model="shopShopAddress.cityId"
                  :disabled="shopShopAddressState == 'check'"
                  placeholder="请选择"
              >
                  <el-option
                      v-for="item in cityIdList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="区域id"
            prop="areaId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopShopAddress.areaId"-->
<!--              :disabled="shopShopAddressState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  size="small"
                  style='width: 200px;'
                  v-model="shopShopAddress.areaId"
                  :disabled="shopShopAddressState == 'check'"
                  placeholder="请选择"
              >
                  <el-option
                      v-for="item in areaIdList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  />
              </el-select>
          </el-form-item>
          <el-form-item
            label="街道id"
            prop="streetId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopShopAddress.streetId"-->
<!--              :disabled="shopShopAddressState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  size="small"
                  style='width: 200px;'
                  v-model="shopShopAddress.streetId"
                  :disabled="shopShopAddressState == 'check'"
                  placeholder="请选择"
              >
                  <el-option
                      v-for="item in streetIdList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  />
              </el-select>
          </el-form-item>
<!--          <el-form-item-->
<!--            label="地址概述"-->
<!--            prop="title"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopShopAddress.title"-->
<!--              :disabled="shopShopAddressState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="详细的地址"
            prop="detailAddress"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopShopAddress.detailAddress"
              :disabled="shopShopAddressState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="纬度"
            prop="latitude"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopShopAddress.latitude"
              :disabled="shopShopAddressState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="经度"
            prop="longitude"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="shopShopAddress.longitude"
              :disabled="shopShopAddressState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否是默认地址"
            prop="isDefault"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopShopAddress.isDefault"-->
<!--              :disabled="shopShopAddressState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  size="small"
                  style='width: 200px;'
                  v-model="shopShopAddress.isDefault"
                  :disabled="shopShopAddressState == 'check'"
                  placeholder="请选择"
              >
                  <el-option
                      label="是"
                      :value="1"
                  />
                  <el-option
                      label="否"
                      :value="0"
                  />
              </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopShopAddressState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import Location from '@/components/location/location.vue';

export default {
    components: {
        Location,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopShopAddressList();
                    this.getShopShopAddressList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopShopAddressList();
                    this.getShopShopAddressList();
                    this.$emit('resetCheckState');
                }
            },
            'shopShopAddress.provinceId'(id) {
                if(!id){
                    return;
                }
                setTimeout(() => {
                    if (!this.getCity) {
                        this.shopShopAddress.cityId = '';
                        this.shopShopAddress.areaId = '';
                        this.shopShopAddress.streetId = '';
                    } else {
                        this.getCity = !this.getCity;
                    }
                    this.getAddress(2,id)
                }, 5);
            },
            //区
            'shopShopAddress.cityId'(id) {
                if(!id){
                    return;
                }
                setTimeout(() => {
                    if (!this.getArea) {
                        this.shopShopAddress.areaId = '';
                        this.shopShopAddress.streetId = '';
                    } else {
                        this.getArea = !this.getArea;
                    }
                    this.getAddress(3,id)
                }, 10);
            },
            //社区
            'shopShopAddress.areaId'(id) {
                if(!id){
                    return;
                }
                setTimeout(() => {
                    if (!this.street) {
                        this.shopShopAddress.streetId = '';
                    } else {
                        this.street = !this.street;
                    }
                    this.getAddress(4,id)
                }, 15);
            },

            'queryForm.provinceId'(id) {
                if(!id){
                    return;
                }
                setTimeout(() => {
                    this.queryForm.cityId = '';
                    this.queryForm.areaId = '';
                    this.queryForm.streetId = '';
                    this.getAddress2(2,id)
                }, 5);
            },
            //区
            'queryForm.cityId'(id) {
                if(!id){
                    return;
                }
                setTimeout(() => {
                    this.queryForm.areaId = '';
                    this.queryForm.streetId = '';
                    this.getAddress2(3,id)
                }, 10);
            },
            //社区
            'queryForm.areaId'(id) {
                if(!id){
                    return;
                }
                setTimeout(() => {
                    this.queryForm.streetId = '';
                    this.getAddress2(4,id)
                }, 15);
            },
        },
    data() {
            return {
                queryForm:{
                     shopId: '', //店铺ID
                     consignee: '', //收货人
                     contactNumber: '', //电话
                     labelName: '', //标签
                     provinceId: '', //省份编号
                     cityId: '', //城市编号
                     areaId: '', //区域id
                     streetId: '', //街道id
                     title: '', //地址概述
                     address: '', //地址
                     detailAddress: '', //详细的地址
                     latitude: '', //纬度
                     longitude: '', //经度
                     isDefault: '', //是否是默认地址 0 不是 1默认地址
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopShopAddressState: 'add',
                shopShopAddressStates: {
                    add: '新建退货地址',
                    check: '查看退货地址',
                    edit: '修改退货地址'
                },

                multipleSelection: [],
                shopShopAddressList: [],
                shopShopAddress: {
                    shopId: '', //店铺ID
                    consignee: '', //收货人
                    contactNumber: '', //电话
                    labelName: '', //标签
                    provinceId: '', //省份编号
                    cityId: '', //城市编号
                    areaId: '', //区域id
                    streetId: '', //街道id
                    title: '', //地址概述
                    address: '', //地址
                    detailAddress: '', //详细的地址
                    latitude: '', //纬度
                    longitude: '', //经度
                    isDefault: '', //是否是默认地址 0 不是 1默认地址
                },
                btnLoading: false,

                rules: {
                    shopId: [{ required: true, message: '店铺ID不能为空', trigger: 'blur' }],
                    consignee: [{ required: true, message: '收货人不能为空', trigger: 'blur' }],
                    contactNumber: [{ required: true, message: '电话不能为空', trigger: 'blur' }],
                    labelName: [{ required: true, message: '标签不能为空', trigger: 'blur' }],
                    provinceId: [{ required: true, message: '省份编号不能为空', trigger: 'blur' }],
                    cityId: [{ required: true, message: '城市编号不能为空', trigger: 'blur' }],
                    areaId: [{ required: true, message: '区域id不能为空', trigger: 'blur' }],
                    streetId: [{ required: true, message: '街道id不能为空', trigger: 'blur' }],
                    title: [{ required: true, message: '地址概述不能为空', trigger: 'blur' }],
                    address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
                    detailAddress: [{ required: true, message: '详细的地址不能为空', trigger: 'blur' }],
                    // latitude: [{ required: true, message: '纬度不能为空', trigger: 'blur' }],
                    // longitude: [{ required: true, message: '经度不能为空', trigger: 'blur' }],
                    isDefault: [{ required: true, message: '是否是默认地址不能为空', trigger: 'blur' }],
                },

                provinceIdList: [], //省信息
                cityIdList: [], //市信息
                areaIdList: [], //区信息
                streetIdList: [],
                getCity: false,//区别是不是get来的
                getArea: false,//区别是不是get来的
                street: false,

                cityIdList2: [], //市信息
                areaIdList2: [], //区信息
                streetIdList2: [],
            };
        },
        created() {
            // this.getShopShopAddressList();
            this.getAddress(1);
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            // 获取对应地址
            getAddress(type, id=null) {
                get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                    if(res.success){
                        let array = []
                        for (let listElement of res.list) {
                            listElement.id = String(listElement.id)
                            array.push(listElement)
                        }
                        if(type == 1){
                            this.provinceIdList = array
                        }else if(type == 2){
                            this.cityIdList = array
                        }else if(type == 3){
                            this.areaIdList = array
                        }else if(type == 4){
                            this.streetIdList = array
                        }
                    }
                })
            },
            // 获取对应地址
            getAddress2(type, id=null) {
                get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                    if(res.success){
                        let array = []
                        for (let listElement of res.list) {
                            listElement.id = String(listElement.id)
                            array.push(listElement)
                        }
                        if(type == 1){
                            this.provinceIdList = array
                        }else if(type == 2){
                            this.cityIdList2 = array
                        }else if(type == 3){
                            this.areaIdList2 = array
                        }else if(type == 4){
                            this.streetIdList2 = array
                        }
                    }
                })
            },
            getLocation(location){
                this.shopShopAddress.longitude = `${location.lng}`
                this.shopShopAddress.latitude = `${location.lat}`
                this.shopShopAddress.address = location.address
                this.getCity = true
                this.getArea = true
                this.street = true
                this.shopShopAddress.provinceId = location.province
                this.shopShopAddress.cityId = location.city
                this.shopShopAddress.areaId = location.area
                this.shopShopAddress.streetId = location.street
            },
            init(id){
                this.queryForm.shopId = id;
                this.shopShopAddress.shopId = id;
                this.currentPage = 1;
                this.shopShopAddressList = [];
                this.getShopShopAddressList();
            },
            resetShopShopAddressList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopShopAddressList = [];
            },
            resetDialog() {
                this.shopShopAddressState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      shopId: this.queryForm.shopId, //店铺ID
                      consignee: '', //收货人
                      contactNumber: '', //电话
                      labelName: '', //标签
                      provinceId: '', //省份编号
                      cityId: '', //城市编号
                      areaId: '', //区域id
                      streetId: '', //街道id
                      title: '', //地址概述
                      address: '', //地址
                      detailAddress: '', //详细的地址
                      latitude: '', //纬度
                      longitude: '', //经度
                      isDefault: '', //是否是默认地址 0 不是 1默认地址
                };
                this.getShopShopAddressList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopShopAddress = {
                      id: '', //
                      shopId: this.shopShopAddress.shopId, //店铺ID
                      consignee: '', //收货人
                      contactNumber: '', //电话
                      labelName: '', //标签
                      provinceId: '', //省份编号
                      cityId: '', //城市编号
                      areaId: '', //区域id
                      streetId: '', //街道id
                      title: '', //地址概述
                      address: '', //地址
                      detailAddress: '', //详细的地址
                      latitude: '', //纬度
                      longitude: '', //经度
                      isDefault: '', //是否是默认地址 0 不是 1默认地址
                };
            },
            submitForm() {
                if (this.shopShopAddressState == 'add') {
                    this.$refs.shopShopAddressForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            let params = this.shopShopAddress
                            params.detailAddress = `${this.shopShopAddress.address}${this.shopShopAddress.detailAddress}`
                            post(`/shop/shopaddress/add`,params).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopShopAddressList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopShopAddressState == 'edit') {
                    this.$refs.shopShopAddressForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            let params = this.shopShopAddress
                            params.detailAddress = `${this.shopShopAddress.address}${this.shopShopAddress.detailAddress}`
                            delete params.province
                            delete params.city
                            delete params.area
                            delete params.street
                            post(`/shop/shopaddress/edit`,params).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopShopAddressList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopShopAddress() {
                this.showDialog = true;
                this.shopShopAddressState = 'add';
            },
            checkShopShopAddress(shopShopAddressId) {
                console.log(shopShopAddressId);
                this.currentShopShopAddressId = shopShopAddressId;

                this.getShopShopAddressById();
                this.showDialog = true;
                this.shopShopAddressState = 'check';
            },
            editShopShopAddress(shopShopAddressId) {
                console.log('shopShopAddress', shopShopAddressId);
                if (shopShopAddressId) {
                    this.currentShopShopAddressId = shopShopAddressId;
                    this.getShopShopAddressById();
                } else {
                    this.shopShopAddress = { ...this.shopShopAddress, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopShopAddressState = 'edit';
            },
            deleteShopShopAddress(shopShopAddressId) {
                let ids = '';
                if (shopShopAddressId) {
                    ids = shopShopAddressId;
                } else {
                    ids = this.multipleSelection.map((shopShopAddress) => shopShopAddress.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/shopaddress/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopShopAddressList();
                                this.getShopShopAddressList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopShopAddressList() {
                this.resetShopShopAddressList();
                this.getShopShopAddressList();
            },
            getShopShopAddressList(query = {}) {
                this.loading = true;
                get(`/shop/shopaddress/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        for (let item of res.page.list) {
                            item.detailAddress = item.detailAddress.slice(item.address.length,item.detailAddress.length)
                        }
                        this.shopShopAddressList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopShopAddressById() {
                get(`/shop/shopaddress/get`,{ id: this.currentShopShopAddressId }).then((res) =>{
                    if(res.success){
                        res.shopShopAddress.detailAddress = res.shopShopAddress.detailAddress.slice(res.shopShopAddress.address.length,res.shopShopAddress.detailAddress.length)
                      this.shopShopAddress = { ...this.shopShopAddress, ...res.shopShopAddress };
                      this.getCity = true
                        this.getArea = true
                        this.street = true
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopShopAddressList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/shopaddress/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/shopaddress/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/shopaddress/importData`,formData);
              this.refreshShopShopAddressList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopShopAddressList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopShopAddressList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>